module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAPCAYAAAACsSQRAAAACXBIWXMAAAsSAAALEgHS3X78AAAA5klEQVQ4T2NgwAKmtu0UiXCY8GFCw1Y7bPLoYozoAtM7drGdOHD7sYgY7+3eRXE2xBjChK7o8plHlzi52D6paEkQ5QqQfhRDShMX7//08buInqmcYWaF2z9iXIGipi5n1fwgy56vU1t3iJOsGaShrWRdnad+269Jzdt1yDKgu2pTvJt2y+/++q1uZBkA1MToY9z54++fv0yfPnxnIdcQBmq4BGw5xWEC8wLFsQMzCJROYl0nv57WvpOHlPDBSPZZIXNu/Pv3n1nfTF6d2ASHkex1TeT0vn/7xXfn2otDpLgGQy2puRgA0+xitp8qeHYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/ButtonSquare/assets/img/back_button_icon_dark.png
// module id = 554
// module chunks = 168707334958949